import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useShowAddonsShop } from '@app/hooks';
import { selectHasAddons } from '@app/redux';
import { selectUserInfo } from '@app/redux/userInfo';

import { NavBarItem } from './NavBarItem';
import { getNavItems } from './utils';
import { NavBarProps } from '../../types';

import styles from './styles.module.scss';

const NavBar = ({ currentTab, handleTabClick }: NavBarProps): JSX.Element => {
  const { t } = useTranslation('Profile');

  const {
    userInfo: { accountType },
  } = useSelector(selectUserInfo);

  const showAddonsShop = useShowAddonsShop();
  const hasAddons = useSelector(selectHasAddons);

  const { navBarItems } = getNavItems(currentTab, accountType, t, showAddonsShop || hasAddons);

  return (
    <div data-cy="profile-nav-bar" className={styles['buttonContainer']}>
      {navBarItems.map((navItem) => (
        <NavBarItem
          key={navItem.id}
          id={navItem.id}
          icon={navItem.icon}
          isActiveTab={navItem.id === currentTab}
          onClick={() => handleTabClick(navItem.id)}
          label={navItem.label}
        />
      ))}
    </div>
  );
};

export default NavBar;
